var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2871 8.95C20.2371 4.33 16.2071 2.25 12.6671 2.25C12.6671 2.25 12.6671 2.25 12.6571 2.25C9.12709 2.25 5.08709 4.32 4.03709 8.94C2.86709 14.1 6.02709 18.47 8.88709 21.22C9.94709 22.24 11.3071 22.75 12.6671 22.75C14.0271 22.75 15.3871 22.24 16.4371 21.22C19.2971 18.47 22.4571 14.11 21.2871 8.95ZM12.6671 13.96C10.9271 13.96 9.51709 12.55 9.51709 10.81C9.51709 9.07 10.9271 7.66 12.6671 7.66C14.4071 7.66 15.8171 9.07 15.8171 10.81C15.8171 12.55 14.4071 13.96 12.6671 13.96Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4742f18f78d8c27d89f6e36d9900a263.svg";
export { ForwardRef as ReactComponent };